import {t} from 'shared/core';
import BackToIndex from 'shared/components/navigation/BackToIndex';

// Wrapper for every report component.
// This component is used by the React Router; don't use it directly in your reports.
const ReportsContainer = ({backPath, children}) => {
  return (
    <div>
      <BackToIndex path={backPath || '/'} title={t('reports.Reports')} hasTitle/>
      <div className='Container'>
        {children}
      </div>
    </div>
  );
};

export default ReportsContainer;
